const Video = ({ url, ...props }: { url: any }) => {
  return (
    <video
      controls
      autoPlay
      muted
      width="100%"
      style={{ aspectRatio: '16/9' }}
      {...props}
    >
      <source src={url} type="video/mp4" />
    </video>
  )
}

export default Video
